import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=192b2e0d&scoped=true&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=192b2e0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192b2e0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192b2e0d')) {
      api.createRecord('192b2e0d', component.options)
    } else {
      api.reload('192b2e0d', component.options)
    }
    module.hot.accept("./Favorites.vue?vue&type=template&id=192b2e0d&scoped=true&", function () {
      api.rerender('192b2e0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Favorites.vue"
export default component.exports